import { Theme, modeForMUI } from '../../types';
var colors = {
    text: {
        primary: '#101828',
        secondary: 'rgba(16, 24, 40, 0.6)',
        disabled: 'rgba(16, 24, 40, 0.38)',
    },
    primary: {
        main: '#0000FF',
        dark: '#00205B',
        light: '#3333FF',
        contrast: '#FCFCFD',
        hover: 'rgba(51, 51, 255, 0.04)',
        selected: 'rgba(51, 51, 255, 0.08)',
        focus: 'rgba(51, 51, 255, 0.12)',
        focusVisible: 'rgba(51, 51, 255, 0.3)',
        outlinedBorder: 'rgba(51, 51, 255, 0.5)',
    },
    secondary: {
        main: '#00205B',
        dark: '#00163F',
        light: '#334C7B',
        contrast: '#FCFCFD',
    },
    error: {
        main: '#FF201C',
        dark: '#B21613',
        light: '#FF4C49',
        contrast: '#FCFCFD',
    },
    warning: {
        main: '#FF9B05',
        dark: '#B26C03',
        light: '#FFAF37',
        contrast: '#FCFCFD',
    },
    info: {
        main: '#00205B',
        dark: '#00163F',
        light: '#334C7B',
        contrast: '#FCFCFD',
    },
    success: {
        main: '#1CE783',
        dark: '#0E8349',
        light: '#43C987',
        contrast: '#101828',
    },
    background: {
        default: '#EDF1F7',
        paper: '#FCFCFD',
    },
    grey: {
        50: '#FCFCFD',
        100: '#F2F4F7',
        200: '#E4E7EC',
        300: '#D0D5DD',
        400: '#98A2B3',
        500: '#667085',
        600: '#475467',
        700: '#344054',
        800: '#1D2939',
        900: '#101828',
    },
    action: {
        active: 'rgba(16, 24, 40, 0.56)',
        hover: 'rgba(16, 24, 40, 0.04)',
        selected: 'rgba(16, 24, 40, 0.08)',
        disabledBackground: 'rgba(16, 24, 40, 0.12)',
        focus: 'rgba(16, 24, 40, 0.12)',
        disabled: 'rgba(16, 24, 40, 0.38)',
    },
    common: {
        white: '#FCFCFD',
        black: '#101828',
    },
    divider: 'rgba(16, 24, 40, 0.12)',
};
export var paletteOptions = {
    palette: {
        mode: modeForMUI[Theme.LIGHT_MODERN],
        text: {
            primary: colors.text.primary,
            secondary: colors.text.secondary,
            disabled: colors.text.disabled,
        },
        primary: {
            main: colors.primary.main,
            dark: colors.primary.dark,
            light: colors.primary.light,
            contrastText: colors.primary.contrast,
        },
        secondary: {
            main: colors.secondary.main,
            dark: colors.secondary.dark,
            light: colors.secondary.light,
            contrastText: colors.secondary.contrast,
        },
        error: {
            main: colors.error.main,
            dark: colors.error.dark,
            light: colors.error.light,
            contrastText: colors.error.contrast,
        },
        warning: {
            main: colors.warning.main,
            dark: colors.warning.dark,
            light: colors.warning.light,
            contrastText: colors.warning.contrast,
        },
        info: {
            main: colors.info.main,
            dark: colors.info.dark,
            light: colors.info.light,
            contrastText: colors.info.contrast,
        },
        success: {
            main: colors.success.main,
            dark: colors.success.dark,
            light: colors.success.light,
            contrastText: colors.success.contrast,
        },
        background: {
            default: colors.background.default,
            paper: colors.background.paper,
        },
        grey: colors.grey,
        action: {
            active: colors.action.active,
            hover: colors.action.hover,
            selected: colors.action.selected,
            disabledBackground: colors.action.disabledBackground,
            focus: colors.action.focus,
            disabled: colors.action.disabled,
        },
        common: {
            white: colors.common.white,
            black: colors.common.black,
        },
        divider: colors.divider,
    },
};
